import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";
import { Text } from "components/shared/text";
import { SvgBartWebIcon, SvgDownload } from "components/svg";
import TabStrip, { Tab } from "components/TabStrip";
import { FC } from "react";
import useTranslation from "utils/hooks/useTranslation";
import { getDownloadButtonTitleKey } from "./helpers";
import { downloadByUrl } from "utils/helpers";

export const DocumentsPopup: FC<{
  product: Accessoire;
  onClose: () => void;
}> = ({ onClose, product }) => {
  const { t } = useTranslation();

  const tabs = [
    { key: "DOCUMENT", title: t("FO_DET_DOCUMENT") },
    { key: "TECHNICAL NOTE", title: t("FO_DET_TECHNICAL_NOTE") },
    { key: "CCTP", title: t("FO_DET_CCTP") },
    { key: "CAD", title: t("FO_DET_CAO") },
  ];

  const items = product.documents;

  return (
    <Popup fixSize="medium" noHeader>
      <group
        data-space="40"
        data-gap="20"
        data-radius="20"
        //data-height="350"
        data-height="fit"
        data-direction="column"
        data-wrap="no"
      >
        <group data-align="center">
          <Text data-text-size="22">FO_POP_UP_DOCUMENT</Text>
          <Button
            mini
            rounded
            accent
            icon="close"
            onClick={() => onClose()}
            data-position="right"
          ></Button>
        </group>
        <separator data-horizontal=""></separator>
        <TabStrip className="custom fit">
          {tabs.map((tab) => {
            const tabDoc = items.filter((doc) => doc.categoryDoc === tab.key);
            return (
              <Tab key={tab.key} title={tab.title}>
                <group
                  data-direction="column"
                  data-space="10"
                  //data-height="300"
                  data-scroll=""
                  data-wrap="no"
                  data-gap="5"
                >
                  {tabDoc.length ? (
                    tabDoc.map((item, i) => (
                      <group
                        key={`${item.nameDoc}_${i}`}
                        data-space="5"
                        //data-gap="15"
                        //data-radius="4"
                        //data-height="54"
                        data-align="center"
                        //data-justify="space-between"
                        data-weight="400"
                        data-text-size="12"
                        data-wrap="no"
                      >
                        <group data-length="autofit">
                          <text>{item.nameDoc}</text>
                        </group>
                        <group data-width="auto" data-wrap="no" data-gap="5">
                          <Button
                            data-background="white"
                            accent
                            data-height="40"
                            text={getDownloadButtonTitleKey(
                              item.typeDoc || "pdf"
                            )}
                            onClick={
                              item.url
                                ? () => downloadByUrl(item.url!, item.nameDoc)
                                : undefined
                            }
                          >
                            <icon data-svg-size="16">
                              {(item.typeDoc === "BART" || item.typeDoc === "WEB") ?
                                <SvgBartWebIcon />
                                :
                                <SvgDownload />
                              }

                            </icon>
                          </Button>
                        </group>
                      </group>
                    ))
                  ) : (
                    <group
                      data-length="auto"
                      data-height="auto"
                      data-align="center"
                      data-justify="center"
                    >
                      <Text>FO_DOC_NULL</Text>
                    </group>
                  )}
                </group>
              </Tab>
            );
          })}
        </TabStrip>
      </group>
    </Popup>
  );
};
